import { render, staticRenderFns } from "./EventCalendarHolidayLabelCard.vue?vue&type=template&id=ad138a24&scoped=true&"
import script from "./EventCalendarHolidayLabelCard.vue?vue&type=script&lang=ts&"
export * from "./EventCalendarHolidayLabelCard.vue?vue&type=script&lang=ts&"
import style0 from "./EventCalendarHolidayLabelCard.vue?vue&type=style&index=0&id=ad138a24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad138a24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VDivider,VIcon})
